export enum AuthResultEnum {
  SUCCESS,
  CANNOT_STORE_VALUES,
  USER_CANCELLED,
  ERROR,
  FORGOT_PASSWORD,
  NOT_AUTHORIZED,
}
